import React from "react";
import { Container } from "react-bootstrap";
import Lottie from "lottie-react";
import elcomAnimation from "../assets/elcom.json";
import "../styles/About.css"; // import CSS

const About = () => {
  return (
    <div className="about-section">
      <Container className="text-center about-container">
        {/* 🎬 Lottie Animation */}
        <div className="animation-wrapper">
          <Lottie
            animationData={elcomAnimation}
            loop={true}
            className="about-animation"
          />
        </div>

        {/* Text Section */}
        <h1 className="about-title">
          Welcome to <span className="highlight">Ghulam Qadir NFT Gallery</span>
        </h1>
        <p className="about-subtitle">
          Here you can explore and buy your favorite digital art NFTs.  
          Our collection features unique creations from talented artists,
          blending creativity with blockchain technology.
        </p>
        <p className="about-text">
          Whether you are a collector, an investor, or simply an admirer of
          digital art, this gallery is the perfect place to discover
          masterpieces that inspire.
        </p>
        <p className="about-quote">
          ✨ Own the art you love. Support artists. Be part of the future of digital creativity. ✨
        </p>
      </Container>
    </div>
  );
};

export default About;
